import { Button, Dropdown } from "react-bootstrap";
import "./vendorprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import editicon from "../../assets/images/edit-icon.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import duplicateicon from "../../assets/images/duplicate-icon.svg";
import { ReactSVG } from "react-svg";
import { Vendor } from "../../redux/vendor/vendorSlice";
import { MouseEventHandler } from "react";
interface VendorProfileHeaderProps {
  selectedVendorData: Vendor;
  updateStatus: any;
  toggleModal: MouseEventHandler<HTMLElement>;
  duplicateVendor: any;
}
const VendorProfileHeader = ({
  selectedVendorData,
  updateStatus,
  toggleModal,
  duplicateVendor,
}: VendorProfileHeaderProps) => {
  return (
    <div className="user-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedVendorData.name}</h2>
        <div
          className={`status-box 
          ${selectedVendorData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          {selectedVendorData?.isActive ? "Active" : "Inactive"}
        </div>
      </div>
      <div className="profile-actions-box">
        <div className="edit-btn-box">
          <Button variant="primary" href="/edit-vendor">
            <i className="bi bi-pencil-square"></i> Edit
          </Button>
        </div>
        <Dropdown>
          <Dropdown.Toggle variant="link" id="dropdown-basic">
            <ReactSVG
              className="svg-box"
              wrapper="span"
              src={threedotvertical}
            />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={toggleModal}>
              <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
              Delete
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                updateStatus();
              }}
            >
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={deactivateicon}
              />
              {selectedVendorData.isActive ? "Deactivate" : "Activate"}
            </Dropdown.Item>
            <Dropdown.Item onClick={duplicateVendor}>
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={duplicateicon}
              />
              Duplicate
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default VendorProfileHeader;
